import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, onMounted } from "vue";
  import { ListingStatus } from "@/enums/ListingStatus";
  import { required, minValue } from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import DatePicker from "@/components/ui/DatePicker.vue";
  import store from "@/store";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { POSITION, useToast } from "vue-toastification";
  import { UserInterface } from "@/types/UserInterface";
  import router from "@/router";
  import { StatesEnum } from "@/enums/StatesEnum";
  import ImageFilesInterface from "@/types/ImagesFilesInterface";
  import dayjs from "dayjs";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { ListingCreateStatus } from "@/enums/ListingCreateStatus";
  import getUserData from "@/helpers/listing/getUserData";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateListing',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const loading = ref(false);
  const agentList = ref([]);
  const maxDate = dayjs().format("YYYY-MM-DD");

  onMounted(() => {
    getUsersSalesPerson();
  });

  const getUsersSalesPerson = () => {
    loading.value = true;
    store
      .dispatch("user/getUsersSalesPerson", {})
      .then((res) => {
        res.data.push({ ...store.state.user.data });
        agentList.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const formFields = {
    headline: null,
    address: {
      state: StatesEnum.WA,
      street: null,
      streetNumber: null,
      suburb: null,
      postcode: null,
      lotNumber: null,
    },
    area: null,
    price: null,
    description: null,
    imageIdCounter: 0,
    imageFiles: [] as ImageFilesInterface[],
    selectedImage: 0,
    agent: getUserData().landownerId,
    agentName: getUserData().name,
    agentEmail: getUserData().email,
    status: ListingStatus.PUBLISHED,
    soldDetails: {
      soldDate: null,
      soldPrice: null,
    },
    phone: store.state.user.data.phone || null,
  };

  const form = reactive({ ...formFields });

  const rules = {
    address: {
      streetNumber: { required },
      street: { required },
      suburb: { required },
      lotNumber: { required },
      state: { required },
      postcode: { required },
    },
    area: { required },
    price: { required },
    description: { required },
    selectedImage: { minValue: minValue(1) },
    agent: { required },
    phone: { required },
    headline: { required },
    status: { required },
  };

  const v$ = useVuelidate(rules, form);

  const uploadImage = (e: any) => {
    if (e.target?.files && e.target.files[0]) {
      const reader = new FileReader();

      reader.onload = (event) => {
        form.imageFiles.push({
          id: form.imageIdCounter,
          data: event.target?.result,
          buffer: e.target.files[0],
        });
      };
      reader.readAsDataURL(e.target.files[0]);
      form.imageIdCounter += 1;
    }

    if (form.imageFiles.length === 0) {
      form.selectedImage = form.imageIdCounter;
    }
  };

  const uploadImageRequest = async () => {
    const formData = new FormData();
    const mainImage = form.imageFiles.find(
      (image) => image.id === form.selectedImage
    );

    if (mainImage) {
      formData.append("files", mainImage?.buffer);
    }

    for (const file of form.imageFiles) {
      if (file.id !== form.selectedImage) {
        formData.append("files", file.buffer);
      }
    }

    try {
      const res = await store.dispatch("listing/uploadImages", formData);

      return res.data.map(
        (image: {
          key: string;
          Location: string;
          format: string;
          updatedAt: Date;
        }) => ({
          url: image.Location,
          format: image.format,
          updatedAt: image.updatedAt,
        })
      );
    } catch (error) {
      return toast.error("Something went wrong, try later", {
        position: POSITION.TOP_LEFT,
      });
    }
  };

  const changeAgent = (agent: UserInterface) => {
    form.agent = agent._id;
    form.agentName = `${agent.firstName} ${agent.lastName}`;
    form.agentEmail = agent.email;
  };

  const saveListing = async (e: Event) => {
    e.preventDefault();
    v$.value.$touch();

    const isFormCorrect = await v$.value.$validate();
    let agentId = getUserData().agentId;
    const userData = getUserData();
    const images = await uploadImageRequest();
    const { soldDetails, ...newForm } = form;
    const requestData = {
      ...newForm,
      landownerId: userData.landownerId,
      estateId: userData.estateId,
      name: form.agentName,
      email: form.agentEmail,
      agentId,
      images,
      salesPersonListingId: form.agent,
      ...(form.status === ListingStatus.SOLD && soldDetails),
    };

    if (!isFormCorrect) {
      return toast.error("The form is not completed or some data is invalid");
    }

    if (!agentId) {
      return toast.error("This estate does not have an agentId configured");
    }

    try {
      const res = await store.dispatch("listing/createListing", requestData);

      if (res.status >= 200 && res.status < 300) {
        toast.success("New listing succesfully created");
        setTimeout(() => {
          router.push("/listing");
        }, 2500);
        return res;
      }

      return res;
    } catch (error) {
      return toast.error("Something went wrong, try later");
    }
  };

  const cancelListing = (e: Event) => {
    e.preventDefault();
    Object.assign(form, formFields);
    router.push("/listing");
  };

const __returned__ = { toast, loading, agentList, maxDate, getUsersSalesPerson, formFields, form, rules, v$, uploadImage, uploadImageRequest, changeAgent, saveListing, cancelListing, reactive, ref, onMounted, get ListingStatus() { return ListingStatus }, get required() { return required }, get minValue() { return minValue }, get useVuelidate() { return useVuelidate }, DatePicker, get store() { return store }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get POSITION() { return POSITION }, get useToast() { return useToast }, get UserInterface() { return UserInterface }, get router() { return router }, get StatesEnum() { return StatesEnum }, get ImageFilesInterface() { return ImageFilesInterface }, get dayjs() { return dayjs }, DropDown, get ListingCreateStatus() { return ListingCreateStatus }, get getUserData() { return getUserData } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})